import o from"./index.module.scss.js";const s=o;export{s as FormElementTheme};
//# sourceMappingURL=index.js.map
